"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayloadEffects = exports.UpNextTimelineEntrySourceFromComponentEffects = exports.ComponentSchema = void 0;
const zod_1 = require("zod");
const accommodation_1 = require("./accommodation");
const flight_1 = require("./flight");
const general_activity_1 = require("./general-activity");
const hire_car_1 = require("./hire-car");
const parking_1 = require("./parking");
const transport_1 = require("./transport");
const up_next_timeline_entry_source_1 = require("./up-next-timeline-entry-source");
exports.ComponentSchema = zod_1.z.object({
    data: zod_1.z.any(),
    renderOptions: zod_1.z.object({
        sectionID: zod_1.z.number(),
    }),
});
const UpNextTimelineEntrySourceFromComponentEffects = (userId) => exports.ComponentSchema.transform((component) => {
    const sectionIdentifier = component.renderOptions.sectionID;
    switch (sectionIdentifier) {
        case 2:
            return (0, flight_1.UNTESFromFlightEffects)(userId).parse(component.data);
        case 3:
            return (0, accommodation_1.UNTESFromAccommodationEffects)(userId).parse(component.data);
        case 4:
            return hire_car_1.UNTESFromHireCarEffects.parse(component.data);
        case 5:
            const parseResult = transport_1.UNTESFromTransportEffects.safeParse(component.data);
            if (parseResult.success) {
                return parseResult.data;
            }
            else {
                return undefined;
            }
            return transport_1.UNTESFromTransportEffects.parse(component.data);
        case 8:
            return general_activity_1.UNTESFromGeneralActivityEffects.parse(component.data);
        case 9:
            return (0, parking_1.UNTESFromParkingEffects)(userId).parse(component.data);
        default:
            throw new zod_1.z.ZodError([
                {
                    code: zod_1.z.ZodIssueCode.custom,
                    message: `Unsupported section identifier received ${sectionIdentifier}`,
                    path: ['renderOptions', 'sectionID'],
                },
            ]);
    }
}).superRefine((entry, ctx) => {
    const parseResult = up_next_timeline_entry_source_1.UNTESSchema.safeParse(entry);
    if (!parseResult.success) {
        for (const issue of parseResult.error.issues) {
            ctx.addIssue(issue);
        }
        return zod_1.z.NEVER;
    }
});
exports.UpNextTimelineEntrySourceFromComponentEffects = UpNextTimelineEntrySourceFromComponentEffects;
const PayloadEffects = (userId, maxEntries = 20) => zod_1.z
    .object({
    past: zod_1.z.record(zod_1.z.string(), zod_1.z.array((0, exports.UpNextTimelineEntrySourceFromComponentEffects)(userId))),
    present: zod_1.z.record(zod_1.z.string(), zod_1.z.array((0, exports.UpNextTimelineEntrySourceFromComponentEffects)(userId))),
})
    .transform((itineraryComponents) => {
    return Object.values(itineraryComponents.present)
        .flat()
        .filter((a) => {
        return a !== undefined;
    })
        .sort((a, b) => {
        return ((a.startOrEnd === 'start'
            ? a.date.timestamp
            : 'checkIn' in a
                ? a.checkIn.timestamp
                : a.date.timestamp) -
            (b.startOrEnd === 'start'
                ? a.date.timestamp
                : 'checkIn' in a
                    ? a.checkIn.timestamp
                    : a.date.timestamp));
    })
        .slice(0, maxEntries);
});
exports.PayloadEffects = PayloadEffects;
